import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<TournamentTeamsReponse, number>({
    query: (id) => ({
      url: `/v4/tournaments/${id}/teams`,
    }),
  });

export type TournamentTeamsReponse = {
  data: {
    [key: string]: MinimalTeam[];
  };
};

export type MinimalTeam = {
  id: number;
  status: number;
  team_number: number;
  player_1: {
    id: number;
    name: string;
    user_id: number;
    ranking: number;
  };
  player_2: {
    id: number;
    name: string;
    user_id: number;
    ranking: number;
  };
};
